
    import {Component, Vue} from 'vue-property-decorator'
    import { colorList } from '@/core/pageConfig'
    import {addMerchantsTag, editMerchantsTag, TagListDto} from "@/api/customerManage";
    import {Getter} from "vuex-class";

    interface TagOption {
        tagId?: string,
        tagName: string,
        tagColor: string,
    }

    @Component({
        name: 'LabelHandle'
    })
    export default class LabelHandle extends Vue {
        formData: TagOption = {
            tagName: '',
            tagColor: ''
        }
        colors: string[] = colorList

        created () {
            if (this.$isEdit) {
                const data = JSON.parse(this.$route.query.data as string)
                this.formData.tagId = data.tagId
                this.formData.tagColor = data.tagColor
                this.formData.tagName = data.tagName
            }
        }

        addSure() {
            (this.$refs.handleForm as any).validate().then(() => {
                if (this.$isEdit) {
                    editMerchantsTag(this.formData).then(() => {
                        this.$toast.success({
                            message: '客户标签修改成功！',
                            duration: 1000,
                            onClose: () => {
                                setTimeout(()=>{
                                  this.$router.back()
                                },200)
                            }
                        })
                    })
                } else {
                    addMerchantsTag(this.formData).then((res) => {
                        this.$toast.success({
                            message: '客户标签新增成功！',
                            duration: 1000,
                            onClose: () => {
                              setTimeout(()=>{
                                if (this.$route.query.isAdd === '1') {
                                  this.$eventBus.$emit('labelAdd', res.data && res.data.id)
                                }
                                this.$router.back()
                              },200)
                            }
                        })
                    })
                }
            });
        }

        changeColor (val: string) {
            this.formData.tagColor = val
        }
    }
